<div class="section-heading action-heading">

  <div>

    <span class="section-kicker">
      Staff page
    </span>

    <h2>
      Staff members
    </h2>

    <p>
      Add or edit public staff profiles.
      Missing photos use the default image.
    </p>

  </div>

  <button
    type="button"
    class="primary-btn"
    (click)="openStaffEditor()"
  >
    ＋ Add staff member
  </button>

</div>


<div class="staff-grid">

  <article
    class="staff-card"
    *ngFor="
      let member of staffMembers;
      trackBy: trackById
    "
  >

    <div
      class="staff-photo"
      [class.placeholder]="!member.imageUrl"
    >

      <img
        *ngIf="member.imageUrl"
        [src]="member.imageUrl"
        [alt]="member.name"
      />

      <svg
        *ngIf="!member.imageUrl"
        viewBox="0 0 64 64"
        aria-label="Default staff image"
      >

        <circle
          cx="32"
          cy="23"
          r="13"
        ></circle>

        <path
          d="M10 58c2-13 10-20 22-20s20 7 22 20"
        ></path>

      </svg>

    </div>


    <div class="staff-info">

      <div class="staff-heading-row">

        <div>

          <h3>
            {{ member.name }}
          </h3>

          <span class="staff-title">
            {{ member.title }}
          </span>

        </div>

        <span
          class="active-pill"
          [class.inactive-pill]="!member.isActive"
        >
          {{ member.isActive ? 'Active' : 'Hidden' }}
        </span>

      </div>

      <p>
        {{ member.bio }}
      </p>

      <small class="display-order">
        Display order: {{ member.displayOrder }}
      </small>

    </div>


    <div class="card-actions">

      <button
        type="button"
        class="edit-btn"
        (click)="openStaffEditor(member)"
      >
        Edit
      </button>

      <button
        type="button"
        class="delete-btn"
        (click)="
          requestDelete(
            'staff',
            member.id,
            member.name
          )
        "
      >
        Delete
      </button>

    </div>

  </article>

</div>


<!-- STAFF EDITOR -->

<div
  *ngIf="staffEditorOpen"
  class="modal-backdrop"
>

  <section
    class="editor-modal"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <header class="modal-header">

      <div>

        <span class="section-kicker">
          Staff page
        </span>

        <h2>
          {{
            staffDraft.id
              ? 'Edit staff member'
              : 'Add staff member'
          }}
        </h2>

      </div>

      <button
        type="button"
        class="close-btn"
        aria-label="Close"
        (click)="closeStaffEditor()"
      >
        ×
      </button>

    </header>


    <form (ngSubmit)="saveStaffMember()">

      <div class="form-grid">

        <div class="form-field">

          <label for="staff-name">
            Full name
          </label>

          <input
            id="staff-name"
            name="staffName"
            [(ngModel)]="staffDraft.name"
            required
          />

        </div>


        <div class="form-field">

          <label for="staff-title">
            Job title
          </label>

          <input
            id="staff-title"
            name="staffTitle"
            [(ngModel)]="staffDraft.title"
            required
          />

        </div>


        <div class="form-field full-width">

          <label for="staff-bio">
            Biography
          </label>

          <textarea
            id="staff-bio"
            name="staffBio"
            rows="5"
            [(ngModel)]="staffDraft.bio"
          ></textarea>

        </div>


        <div class="form-field">

          <label for="staff-display-order">
            Display order
          </label>

          <input
            id="staff-display-order"
            name="staffDisplayOrder"
            type="number"
            min="0"
            [(ngModel)]="staffDraft.displayOrder"
          />

          <small>
            Lower numbers appear first on
            the public Staff page.
          </small>

        </div>


        <div class="form-field visibility-field">

          <label for="staff-active">
            Profile visibility
          </label>

          <label class="checkbox-label">

            <input
              id="staff-active"
              name="staffIsActive"
              type="checkbox"
              [(ngModel)]="staffDraft.isActive"
            />

            Display this staff member

          </label>

        </div>

      </div>


      <div class="upload-field">

        <div
          class="upload-preview staff-photo"
          [class.placeholder]="!staffDraft.imageUrl"
        >

          <img
            *ngIf="staffDraft.imageUrl"
            [src]="staffDraft.imageUrl"
            alt="Staff preview"
          />

          <svg
            *ngIf="!staffDraft.imageUrl"
            viewBox="0 0 64 64"
            aria-label="Default staff image"
          >
            <circle
              cx="32"
              cy="23"
              r="13"
            ></circle>

            <path
              d="M10 58c2-13 10-20 22-20s20 7 22 20"
            ></path>
          </svg>

        </div>


        <div>

          <strong>
            Profile photo
          </strong>

          <p>
            The default profile image is used
            until a photo is added.
          </p>

          <div class="upload-actions">

            <label class="secondary-btn file-btn">

              Choose photo

              <input
                type="file"
                accept="image/*"
                (change)="onImageSelected($event)"
              />

            </label>

            <button
              *ngIf="staffDraft.imageUrl"
              type="button"
              class="text-btn"
              (click)="removeDraftImage()"
            >
              Use default image
            </button>

          </div>

        </div>

      </div>


      <div class="form-actions modal-actions">

        <button
          type="button"
          class="text-btn"
          (click)="closeStaffEditor()"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="primary-btn"
        >
          Save staff member
        </button>

      </div>

    </form>

  </section>

</div>


<!-- DELETE CONFIRMATION -->

<div
  *ngIf="deleteRequest"
  class="modal-backdrop confirm-backdrop"
  (click)="cancelDelete()"
>

  <section
    class="confirm-modal"
    role="alertdialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <div class="confirm-icon">
      !
    </div>

    <h2>
      Delete “{{ deleteRequest.label }}”?
    </h2>

    <p>
      This staff member will be permanently removed.
      This action cannot be undone.
    </p>

    <div class="form-actions">

      <button
        type="button"
        class="secondary-btn"
        (click)="cancelDelete()"
      >
        Cancel
      </button>

      <button
        type="button"
        class="danger-btn"
        (click)="confirmDelete()"
      >
        Delete permanently
      </button>

    </div>

  </section>

</div>